module.exports = __webpack_public_path__ + "img/icon-up.4e0fd9a1.png";